import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { IconUsers, IconAcademy, IconTag, IconTrophy, IconBolt, IconWallet } from '../components/icons';
import { alunosAPI, academiasAPI, financeiroAPI } from '../services/api';
import { CampeonatosService } from '../services/campeonatosService';
import './Home.css';

const fmtMoeda = (v) => `R$ ${parseFloat(v || 0).toFixed(0)}`;

function Home() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    Promise.all([
      alunosAPI.getAll(),
      academiasAPI.getAll(),
      CampeonatosService.listar(),
      financeiroAPI.resumo(),
    ])
      .then(([alunos, academias, campeonatos, fin]) => {
        setStats({
          alunos: alunos.data.length,
          academias: academias.data.length,
          campeonatosAtivos: campeonatos.filter((c) => c.status === 'INSCRIÇÕES ABERTAS').length,
          receitaConfirmada: fin.data.geral.receita_confirmada,
          pendentes: parseInt(fin.data.geral.pendentes, 10) || 0,
        });
      })
      .catch(() => setStats(null));
  }, []);

  return (
    <div className="home">
      <div className="home-hero">
        <div className="home-hero-grid" />
        <div className="home-hero-content">
          <h1 className="home-hero-title">Painel administrativo</h1>
          <p className="home-hero-sub">Gerencie atletas, academias, categorias e gere chaves de competição automaticamente.</p>
          <a href="http://localhost:3200" target="_blank" rel="noopener noreferrer" className="home-hero-link">
            Ver página institucional de eventos →
          </a>
        </div>

        {stats && (
          <div className="home-hero-stats">
            <div className="home-stat">
              <span>Campeonatos ativos</span>
              <b>{stats.campeonatosAtivos}</b>
            </div>
            <div className="home-stat">
              <span>Atletas cadastrados</span>
              <b>{stats.alunos}</b>
            </div>
            <div className="home-stat">
              <span>Academias</span>
              <b>{stats.academias}</b>
            </div>
            <div className="home-stat">
              <span>Receita confirmada</span>
              <b>{fmtMoeda(stats.receitaConfirmada)}</b>
            </div>
            <div className="home-stat">
              <span>Pagamentos pendentes</span>
              <b className={stats.pendentes > 0 ? 'amber' : ''}>{stats.pendentes}</b>
            </div>
          </div>
        )}
      </div>

      <div className="home-nav-grid">
        <Link to="/campeonatos" className="home-nav-card">
          <IconTrophy />
          <div>
            <h3>Campeonatos</h3>
            <p>Crie e gerencie competições do início ao fim</p>
          </div>
        </Link>
        <Link to="/financeiro" className="home-nav-card">
          <IconWallet />
          <div>
            <h3>Financeiro</h3>
            <p>Receita, pendências e conciliação de pagamentos</p>
          </div>
        </Link>
        <Link to="/gerar-chaves" className="home-nav-card">
          <IconBolt />
          <div>
            <h3>Gerar chaves</h3>
            <p>Sorteio automático de lutas por categoria</p>
          </div>
        </Link>
        <Link to="/alunos" className="home-nav-card">
          <IconUsers />
          <div>
            <h3>Alunos</h3>
            <p>Cadastro completo dos atletas participantes</p>
          </div>
        </Link>
        <Link to="/academias" className="home-nav-card">
          <IconAcademy />
          <div>
            <h3>Academias</h3>
            <p>Cadastre e organize as equipes participantes</p>
          </div>
        </Link>
        <Link to="/categorias" className="home-nav-card">
          <IconTag />
          <div>
            <h3>Categorias</h3>
            <p>Configure categorias por peso, idade e faixa</p>
          </div>
        </Link>
      </div>
    </div>
  );
}

export default Home;
